import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { useStore } from './stores/Store';
import { View } from '@aws-amplify/ui-react';
import SignIn from './pages/signIn';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRouter from './PrivateRouter';
import { LoadingScreen } from './components';
// import PrivateRouter from './privateRouter';

const App = (() => {
  const store = useStore();
  // useEffect(() => {
  //   const handleResize = () => {
  //     const screenWidth = window.innerWidth;
  //     const screenHeight = window.innerHeight;
  //     store.setScreenWidth(screenWidth);
  //     store.setScreenHeight(screenHeight);
  //   };
  //   window.addEventListener('resize', handleResize);
  // }, []);

  // useEffect(() => {
  //   const handleResize = () => {
  //       const screenWidth = window.innerWidth;
  //       const screenHeight = window.innerHeight;
  //       store.setScreenWidth(screenWidth);
  //       store.setScreenHeight(screenHeight);
  //   };
  //   window.addEventListener('resize', handleResize);


  //   document.addEventListener("gesturestart", function (e) {
  //     e.preventDefault();
  //       document.body.style.zoom = 0.99;
  //   });

  //   document.addEventListener("gesturechange", function (e) {
  //     e.preventDefault();

  //     document.body.style.zoom = 0.99;
  //   });
  //   document.addEventListener("gestureend", function (e) {
  //       e.preventDefault();
  //       document.body.style.zoom = 1;
  //   });

  // }, []);


  // window.addEventListener('resize', () => {
  // })
  return (
    <Router>
      <View className="App" style={{ minHeight: `${window.innerHeight}px`, overflow: 'hidden' }}>
       <LoadingScreen/>
        <Routes>
          <Route path="/login" element={<SignIn />} />
          <Route path='*' element={<Navigate to='/login' />} />
          <Route path="/AdminDashboard" element={<PrivateRouter><AdminDashboard /></PrivateRouter>} />
        </Routes>
      </View>
    </Router>
  )

})

export default App;
